/* WEAR ADN — Fondu mobile
   Sur téléphone (pas de souris), chaque vignette produit passe toute seule
   de la 1re image (logo) à la 2e (mannequin), en fondu, puis revient.
   Sur ordinateur : rien ne change, le survol reste comme avant. */
(function () {
  if (!window.matchMedia) return;
  if (!window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css =
    '.adn-fondu{position:absolute;inset:0;z-index:2;pointer-events:none;overflow:hidden;' +
    'opacity:0;animation:adnFondu 7s ease-in-out infinite;animation-delay:var(--adn-delai,0s)}' +
    '.adn-fondu img{width:100%;height:100%;object-fit:var(--product-media-fit,cover);display:block}' +
    '@keyframes adnFondu{0%,38%{opacity:0}50%,88%{opacity:1}100%{opacity:0}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var compteur = 0;

  function preparer(galerie) {
    if (galerie.dataset.adnFondu) return;
    var slides = galerie.querySelectorAll('slideshow-slide:not([hidden])');
    if (slides.length < 2) return;
    var premiere = slides[0];
    var imgSource = slides[1].querySelector('img');
    if (!premiere || !imgSource) return;
    galerie.dataset.adnFondu = '1';

    var clone = imgSource.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('alt', '');
    clone.setAttribute('loading', 'eager');
    clone.removeAttribute('fetchpriority');

    var couche = document.createElement('div');
    couche.className = 'adn-fondu';
    couche.setAttribute('aria-hidden', 'true');
    couche.style.setProperty('--adn-delai', (compteur % 3) * 1.2 + 's');
    compteur++;
    couche.appendChild(clone);

    if (getComputedStyle(premiere).position === 'static') premiere.style.position = 'relative';
    premiere.appendChild(couche);
  }

  function tout() {
    var galeries = document.querySelectorAll('.card-gallery');
    for (var i = 0; i < galeries.length; i++) preparer(galeries[i]);
  }

  var attente;
  function plusTard() {
    clearTimeout(attente);
    attente = setTimeout(tout, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  window.addEventListener('load', tout);
  new MutationObserver(plusTard).observe(document.documentElement, { childList: true, subtree: true });
})();
